import en from "./en.json";
import no from "./no.json";

const languages = [en, no];
export default languages;
